import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: false,
    field: 'ticketName',
    title: 'Ticket Name',
    show: true,
    width: 332,
    valuesExport: ['ticketName']
  },
  {
    isSortable: false,
    field: 'messages',
    title: 'Ticket Thread',
    show: true,
    width: 382,
    valuesExport: ['messages']
  },
  {
    isSortable: true,
    field: 'ticketId',
    title: 'Ticket ID',
    show: true,
    width: 117,
    valuesExport: ['ticketId']
  },
  {
    isSortable: true,
    field: 'ticketStatus',
    title: 'Status',
    show: true,
    width: 112,
    valuesExport: ['ticketStatus']
  },
  {
    isSortable: true,
    field: 'requesterName',
    title: 'Requester Name',
    show: true,
    width: 282,
    valuesExport: ['requesterName', 'requesterEmail']
  },
  {
    isSortable: true,
    field: 'requesterRole',
    title: 'Role',
    show: true,
    width: 132,
    valuesExport: ['requesterRole']
  },
  {
    isSortable: true,
    field: 'priority',
    title: 'Priority',
    show: true,
    width: 132,
    valuesExport: ['priority']
  },
  {
    isSortable: true,
    field: 'assigneeName',
    title: 'Assignee',
    show: true,
    width: 282,
    valuesExport: ['assigneeName', 'assigneeEmail']
  },
  {
    isSortable: true,
    field: 'createdAt',
    title: 'Created At',
    show: true,
    width: 142,
    valuesExport: ['createdAt']
  },
  {
    isSortable: true,
    field: 'lastUpdatedAt',
    title: 'Last Updated',
    show: true,
    width: 152,
    valuesExport: ['lastUpdatedAt']
  },
  {
    isSortable: false,
    field: 'responseTime',
    title: 'Response Time',
    show: true,
    width: 112,
    valuesExport: ['responseTime']
  },
  {
    isSortable: true,
    field: 'solvedAt',
    title: 'Solved AT',
    show: true,
    width: 112,
    valuesExport: ['solvedAt']
  },
  {
    isSortable: true,
    field: 'openToSolveTimeDays',
    title: 'Solved Time',
    show: true,
    width: 144,
    valuesExport: ['openToSolveTimeDays']
  }
];

export const exportConfigTickets = {
  exportUrl: '/customer/satisfaction/tickets/export',
  exportName: 'tickets',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  requesterRole: [],
  ticketStatus: [],
  priority: [],
  assigneeName: [],
  createdAt: { startDate: null, endDate: null },
  lastUpdatedAt: { startDate: null, endDate: null }
};

export const defaultNavigation = {
  fieldName: 'lastUpdatedAt',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const chartColor = {
  closed: '#4dc9f6',
  hold: '#ac89f3',
  open: '#ff829d',
  pending: '#fbdf9c',
  solved: '#6fcdcd'
};
